// getters types
export const GET_USER = "auth/SET_USER";
// mutations types

export const SET_USER = "auth/SET_USER";

// ations types
export const LOGOUT_USER = "auth/LOGOUT_USER";
export const LOGIN_USER = "auth/LOGIN_USER";
